import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { Clipboard } from '@angular/cdk/clipboard';
import { TranslateService } from '@ngx-translate/core';
import { Snackbars } from '../../groups/shared/dialogs/Snackbars';
import { ApiErrorParser } from '../apiErrorParser';

export interface CardTerminalAdminPinDialogData {
  /** The terminal's label, shown in the dialog. */
  label: string;
  /** Reads the PIN; a terminal registered before PINs of its own gets one with it. */
  loadPin: () => Promise<string>;
}

/**
 * The PIN of a card terminal's admin menu, where a new pairing code is made. Every terminal has one of its own,
 * for the owner and the support only.
 */
@Component({
  selector: 'app-card-terminal-admin-pin-dialog',
  templateUrl: './card-terminal-admin-pin-dialog.component.html',
})
export class CardTerminalAdminPinDialogComponent implements OnInit {
  public pin = '';
  public isLoading = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: CardTerminalAdminPinDialogData,
    private dialogRef: MatDialogRef<CardTerminalAdminPinDialogComponent>,
    private snackBar: MatSnackBar,
    private clipboard: Clipboard,
    private translate: TranslateService,
    private apiErrorParser: ApiErrorParser
  ) {}

  async ngOnInit(): Promise<void> {
    try {
      this.pin = await this.data.loadPin();
    } catch (error) {
      Snackbars.errorSnackBar(
        this.apiErrorParser.extractErrorMessage(error),
        this.snackBar
      );
      this.dialogRef.close();
    } finally {
      this.isLoading = false;
    }
  }

  public copyPin(): void {
    if (this.pin) {
      this.clipboard.copy(this.pin);
      Snackbars.infoSnackBar(
        this.translate.instant('cardterminals.pin.copied'),
        this.snackBar
      );
    }
  }

  public close(): void {
    this.dialogRef.close();
  }
}
